import React, { useState } from 'react'

function Mailboxcontent1({onNext}) {
    const [isChecked, setIsChecked] = useState(false);
    const [isError, setIsError] = useState(false);


    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
    };


    const handleNextClick = async () => {
        if (!isChecked) {
            setIsError(true);
            return;
        }
        else {
            onNext()
        }
    };
    return (
        <div className="r-content r-mailbox">
            <h4 className="content-title">Safe Use of the Application:</h4>
            <p className="content-text">
                Ensure your identity remains protected by avoiding sharing personal
                information in forms or attachments. Use a secure internet connection
                with a lock symbol in your browser. Access the application or your
                mailbox only through a private device. Trusty AG, the developer, ensures
                no IP addresses are recorded and only uses temporary cookies for
                security. All communication is encrypted.
            </p>
            <br />
            <h4 className="content-title">Safe Use of the Application:</h4>
            <div className="content-text">
                The Olympic Committee of Slovenia manages all personal data transmitted
                through the application.
            </div>
            <button className="content-moredetails">More Details</button>
            <form method="POST" className="agreement">
                <label
                    className={`check-agreement ${isError ? 'error' : ''}`} // Add error class if there's an error
                >
                    <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                        id="agreementscheckbox"
                    />
                    I confirm that I have read and understood the confidentiality notices
                </label>
            </form>
            <div className="back-next">
                <button className="Backbtn">Back</button>
                <button className="Nextbtn" onClick={handleNextClick}>
                    Next
                </button>
            </div>
        </div>
    );
}

export default Mailboxcontent1